<ng-container *ngIf="context.recordId as id">
  <ng-container *ngTemplateOutlet="itemTemplate; context: {id: id}">
  </ng-container>
</ng-container>
